import { StyleSheet, View, ViewProps } from 'react-native';

import React from 'react';
import { Text } from '@ui-kitten/components';

//props
interface IAssessmentScoreProps extends ViewProps {
  caption: string;
  score: string;
  textCategory: string;
}

const AssessmentScore = (props: IAssessmentScoreProps) => {
  // styles
  const styleContainer = StyleSheet.create({
    container: { flex: 1, paddingRight: 20 }
  });

  // view
  return (
    <View style={[styleContainer.container, props.style]}>
      <Text category="c1" appearance="hint">
        {props.caption}
      </Text>
      <Text category={props.textCategory}>{props.score}</Text>
    </View>
  );
};

export default AssessmentScore;
